import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrencyFormatService {

  constructor() { }

  formatAmount(amount): string {
    if (amount == '' || amount == null) return '$0.00';
    const absAmount = Math.abs(amount);
    const formattedAmount = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(absAmount);
    return parseFloat(amount) < 0 ? `-${formattedAmount}` : formattedAmount;
  }
}
